<article class="esig-config-section" [ngClass]="[eSigConfigOpen ? 'esig-config-open' : 'esig-config-closed', renderMode]">
  <!-- TODO: Amend tooltip when we know the Esignature service -->
  @if (renderMode === 'web-app') {
    <mat-icon
      fontIcon="expand_less"
      class="expand-section-icon"
      [matTooltip]="eSigConfigOpen ? 'Close config' : 'Edit ----ESIGNATURE-SERVICE---- config before sending'"
      matTooltipShowDelay="500"
      (click)="expandESigConfig(eSigConfigOpen)"
      (keydown.enter)="expandESigConfig(eSigConfigOpen)"
      (keydown.space)="expandESigConfig(eSigConfigOpen)"
      role="button"
      [attr.tabindex]="eSigConfigOpen ? 0 : -1"
    ></mat-icon>
  }

  <!--// Button-->
  @if (renderMode === 'web-app') {
    <section
      id="esig-config-button"
      class="expansion-button"
      [matTooltip]="'Edit recipients and email before sending'"
      matTooltipShowDelay="500"
      matTooltipPosition="above"
      [attr.tabindex]="eSigConfigOpen ? -1 : 0"
      (click)="expandESigConfig(false)"
      (keydown.enter)="expandESigConfig(false)"
      (keydown.space)="expandESigConfig(false)"
      >
      <h2 class="box-title-bar">
        <span class="box-title-text with-tip">
          <mat-icon fontIcon="settings"></mat-icon>
          <span class="main-title-text">Edit Docusign Config</span>
          @if (!eSigConfigOpen) {
            <span class="small info-tip"
              ><mat-icon fontIcon="info_outline"></mat-icon> Edit {{ existingRecipientText }} recipients and email before sending</span
              >
            }
            <mat-icon fontIcon="settings" class="big-watermark-icon"></mat-icon>
          </span>
        </h2>
      </section>
    }

    @if (eSigConfigOpen) {
      <section>
        <form [formGroup]="eFormGroup" #configFocus>
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="panel === 1 || !recipientsFormArray.valid"
              (opened)="setPanel(1)"
              (afterExpand)="focusPanel(autoFocus1)"
              (closed)="panelClosed(1)"
              [disabled]="!signatureEnabled"
              >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon fontIcon="people"></mat-icon>
                  Edit recipients
                  @if (renderMode === 'web-app') {
                    <mat-panel-description> Email addresses and signing order </mat-panel-description>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul id="recipients" (cdkDropListDropped)="drop($event)" cdkDropList>
                @if (recipientsFormArray.controls.length === 0) {
                  <li class="no-results">Add recipients below</li>
                }
                <ng-container formArrayName="recipients">
                  @for (recipient of recipientsFormArray.controls; track recipient; let i = $index) {
                    <li
                      [ngClass]="getFormControl(i, 'editing').value ? 'editing' : null"
                      cdkDrag
                      >
                      <div
                        class="recipient-details"
                        [matTooltip]="recipient.value.name + ' - ' + recipient.value.email + ' - ' + recipient.getRawValue().role"
                        matTooltipPosition="above"
                        matTooltipShowDelay="500"
                        >
                        @if (!getFormControl(i, 'editing').value) {
                          <mat-icon fontIcon="person"></mat-icon>
                          {{ recipient.value.name }}
                          @if (renderMode === 'web-app' && recipient.value.email) {
                            <span>
                              <mat-icon fontIcon="email"></mat-icon>
                              {{ recipient.value.email }}
                            </span>
                          }
                          @if (renderMode === 'web-app' && recipient.getRawValue().role && showRecipientRole) {
                            <span>
                              <mat-icon fontIcon="work"></mat-icon>
                              {{ recipient.getRawValue().role }}
                            </span>
                          }
                        }
                        @if (getFormControl(i, 'editing').value) {
                          <div [formGroupName]="i">
                            <span class="edit-name"
                              ><mat-icon fontIcon="person"></mat-icon
                              ><input
                              [formControl]="getFormControl(i, 'name')"
                              placeholder="e.g. Jane Doe"
                              (mousedown)="$event.stopPropagation()"
                              #editNameInput
                            /></span>
                            <span class="edit-email"
                              ><mat-icon fontIcon="email"></mat-icon
                              ><input
                              #recipientEmailInput
                              type="email"
                              [formControl]="getFormControl(i, 'email')"
                              placeholder="e.g. Jane.Doe@KyloePartners.com"
                              (mousedown)="$event.stopPropagation()"
                            /></span>
                            @if (showRecipientRole) {
                              <span class="edit-role">
                                <mat-icon fontIcon="work"></mat-icon>
                                <input [formControl]="getFormControl(i, 'role')" (mousedown)="$event.stopPropagation()" />
                              </span>
                            }
                          </div>
                          @if (!recipientsFormArray.controls[i].valid) {
                            <button
                              class="confirm-recipient-edit red"
                              tabindex="0"
                              [matTooltip]="'Amend any invalid details'"
                              matTooltipShowDelay="500"
                              >
                              <mat-icon fontIcon="info_outline"></mat-icon>
                            </button>
                          }
                          @if (recipientsFormArray.controls[i].valid) {
                            <button
                              class="confirm-recipient-edit"
                              tabindex="0"
                              [matTooltip]="'Accept changes'"
                              matTooltipShowDelay="500"
                              [disabled]="recipient.invalid"
                              (click)="acceptRecipientEdits(i)"
                              >
                              <mat-icon fontIcon="done"></mat-icon>
                            </button>
                          }
                        }
                      </div>
                      @if (!getFormControl(i, 'editing').value) {
                        <mat-icon
                          id="edit-item-{{ i }}"
                          (click)="toggleEditRecipient(i)"
                          fontIcon="edit"
                          (keydown.enter)="toggleEditRecipient(i)"
                          (keydown.space)="toggleEditRecipient(i)"
                          [matTooltip]="'Edit recipient'"
                          matTooltipShowDelay="500"
                          tabindex="0"
                        ></mat-icon>
                        <mat-icon
                          id="remove-item-{{ i }}"
                          class="remove"
                          (click)="removeRecipient(i)"
                          fontIcon="close"
                          (keydown.enter)="removeRecipient(i)"
                          (keydown.space)="removeRecipient(i)"
                          [matTooltip]="'Remove recipient'"
                          matTooltipShowDelay="500"
                          tabindex="0"
                        ></mat-icon>
                        <mat-icon
                          fontIcon="drag_indicator"
                          id="drag-indicator-{{ i }}"
                          [matTooltip]="'Reorder this recipient'"
                          matTooltipShowDelay="500"
                        ></mat-icon>
                      }
                    </li>
                  }
                </ng-container>
              </ul>
              <!--            <span style="background-color: lightgreen">{{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}</span>-->
              <aside id="add-recipient">
                <section class="footer-btns">
                  <button
                    theme="nav"
                    id="add-person-button"
                    class="add-recipient-button"
                    (click)="addPersonButton()"
                    [ngClass]="addPerson ? 'selected' : ''"
                    #autoFocus1
                    >
                    @if (renderMode === 'web-app') {
                      Add a Recipient
                    }
                    @if (renderMode === 'chrome-extension') {
                      Recipient
                    }
                    <mat-icon fontIcon="add"></mat-icon>
                  </button>
                  <button
                    theme="nav"
                    id="add-{{ namespace }}-entity-button"
                    class="add-recipient-button"
                    (click)="addEntityButton()"
                    [ngClass]="addEntity ? 'selected' : ''"
                    >
                    @if (renderMode === 'web-app') {
                      {{ addRecipientButtonLabel }}
                    }
                    @if (renderMode === 'chrome-extension') {
                      {{ namespace }}
                    }
                    <mat-icon fontIcon="add"></mat-icon>
                  </button>
                </section>
                @if (addPerson) {
                  <app-add-recipient
                    [emailRequired]="true"
                    [recipientType]="'person'"
                    (emitAddRecipient)="addRecipient($event)"
                    @transitionNewRecipientInOut
                    >
                  </app-add-recipient>
                }
                @if (addEntity) {
                  <app-add-recipient
                    [recipientType]="namespace"
                    (emitAddRecipient)="addRecipient($event)"
                    @transitionNewRecipientInOut
                    >
                  </app-add-recipient>
                }
              </aside>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="panel === 2"
              (opened)="setPanel(2)"
              (afterExpand)="focusPanel(autoFocus2)"
              (closed)="panelClosed(2)"
              [disabled]="!signatureEnabled"
              >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon fontIcon="email">email</mat-icon>
                  Email
                  @if (renderMode === 'web-app') {
                    <mat-panel-description> Subject and message in your email </mat-panel-description>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <table class="table-full-width table-striped table-td-border-right">
                <tr>
                  <td colspan="3">
                    <label for="emailSubject">Email subject</label>
                    <input
                      id="emailSubject"
                      name="emailSubject"
                      formControlName="emailSubject"
                      type="text"
                      placeholder="e.g. Documents to sign"
                      #autoFocus2
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <label for="emailBody">Email message body</label>
                      <textarea id="emailBody" formControlName="emailBody" rows="10"></textarea>
                    </td>
                  </tr>
                </table>
              </mat-expansion-panel>
            </mat-accordion>
          </form>
        </section>
      }
    </article>
